import { createContext } from "react";
import { useGetPatientSubscriptionsByIdQuery } from "src/api/services/subscriptionsApi";
import { PatientSubscriptions } from "src/api/types";

export const SubscriptionsContext = createContext<PatientSubscriptions[]>([]);

interface Props {
  children: React.ReactNode;
  patientId: number;
}

const SubscriptionsProvider = ({ children, patientId }: Props) => {
  const { data: subscriptions = [] } =
    useGetPatientSubscriptionsByIdQuery(patientId);

  return (
    <SubscriptionsContext.Provider value={subscriptions}>
      {children}
    </SubscriptionsContext.Provider>
  );
};

export default SubscriptionsProvider;
